document.addEventListener("DOMContentLoaded", function () {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let shirtCount = 0;
      cart.items.forEach(item => {
        if (item.product_type.toLowerCase() === "shirt") {
          shirtCount += item.quantity;
        }
      });

      if (shirtCount >= 2) {
        let popup = document.getElementById("free-boxer-popup");
        if (popup) {
          popup.style.display = "block";
          setTimeout(() => popup.style.display = "none", 5000);
        }
      }
    });
});
